import { NoRecordFoundV2 } from 'components/Common/Common' 
import TextInputV2 from 'components/Common/TextInputV2'
import React from 'react'
import { Col, Row } from 'react-bootstrap'

function Step1({ data, values, setFieldValue }) {
    return (
        <div className='pe-lg-5'>
            <div style={{ marginTop: "15px" }}>
                <h5 className="profile-title">1. PROFILE INFORMATION</h5>
                <div className="d-flex flex-column gap-4">
                    <Row>
                        <Col md="6" className='d-flex gap-4'>
                            <TextInputV2
                                required
                                name="lastname"
                                label='Last Name'
                                value={values?.lastname}
                                onChange={(e) => setFieldValue("lastname", e.target.value)}
                            />
                            <TextInputV2
                                required
                                name="firstname"
                                label='First Name'
                                value={values?.firstname}
                                onChange={(e) => setFieldValue("firstname", e.target.value)}
                            />
                        </Col>
                        <Col md="3">
                            <TextInputV2
                                required
                                name="email"
                                label='Email' type='email'
                                value={values?.email}
                                disabled
                            />
                        </Col>
                        <Col md="3">
                            <TextInputV2
                                required
                                name="phone"
                                label='Phone Number'
                                type='number'
                                value={values?.phone}
                                onChange={(e) => setFieldValue("phone", e.target.value)}

                            />
                        </Col>
                    </Row> 
                  
                </div>
            </div> 

        </div>
    )
}

export default Step1
